import * as React from 'react';
export const pilotSvg = React.forwardRef(function pilotSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#5F2EE5',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.502 4.79a8.47 8.47 0 0 0-5.704 2.195V5.158H8v23.058h2.798v-8.628a8.502 8.502 0 0 0 13.634-3.248 8.5 8.5 0 0 0-7.93-11.556v.005Zm0 14.202a5.704 5.704 0 1 1 .015-11.408 5.704 5.704 0 0 1-.015 11.408Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.502 15.413a2.174 2.174 0 1 0 0-4.348 2.174 2.174 0 0 0 0 4.348Z',
      fill: '#fff',
    }),
  );
});
pilotSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pilot = {
  category: 'brand',
  colorable: false,
  name: 'pilot',
  svg: pilotSvg,
};
